module.exports = __webpack_public_path__ + "static/media/Jon Snow 2.b730e4f9.jpg";